import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";
import { buildChartData } from "../components/Charts/chartDataService";

const REQUEST_CHART_SENSORS = "REQUEST_CHART_SENSORS";
const RESPONSE_CHART_SENSORS = "RESPONSE_CHART_SENSORS";
const REQUEST_CHART_SENSORS_FAILURE = "REQUEST_CHART_SENSORS_FAILURE";
const CLEAR_CHART_SENSORS = "CLEAR_CHART_SENSORS";

const requestChartSensorsAction = () => {
  return {
    type: REQUEST_CHART_SENSORS,
  };
};

const responseChartSensorsAction = (data) => {
  return {
    type: RESPONSE_CHART_SENSORS,
    data,
  };
};

const requestChartSensorsFailureAction = (errors) => {
  return {
    type: REQUEST_CHART_SENSORS_FAILURE,
    errors,
  };
};

const getChartSensors = (options, chartReport) => {
  return (dispatch) => {
    dispatch(requestChartSensorsAction());

    intellegenceService
      .getChartSensors(
        options.carId,
        {
          startDate: getDates.fixISOStringDateToPost(options.startDate),
          endDate: getDates.fixISOStringDateToPost(options.endDate),
          timeZone: (new Date().getTimezoneOffset() / 60) * -1,
        },
        chartReport.id
      )
      .then((result) => {
        dispatch(responseChartSensorsAction(buildChartData(result.data, chartReport, options.carId)));
      })
      .catch((error) => {
        dispatch(requestChartSensorsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearChartSensorsAction = () => {
  return {
    type: CLEAR_CHART_SENSORS,
  };
};

export {
  REQUEST_CHART_SENSORS,
  RESPONSE_CHART_SENSORS,
  REQUEST_CHART_SENSORS_FAILURE,
  CLEAR_CHART_SENSORS,
  requestChartSensorsAction,
  responseChartSensorsAction,
  requestChartSensorsFailureAction,
  getChartSensors,
  clearChartSensorsAction,
};
